module.exports = __webpack_public_path__ + "static/media/react.d14e4fd3.png";